import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { visuallyHidden } from "@mui/utils";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import Dialog from "@mui/material/Dialog";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import {
  RemoveRedEyeIcon,
  SearchIcon,
  DeleteIcon,
  DownloadIcon,
  RestartAltIcon,
  CloudOffIcon,
  EditIcon,
} from "../../../Resources/Icons/icons";
import moment from "moment";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { PolicyFilterTypes } from "../../../Shared/CommonConstant";
import {
  GetPolicyList,
  DeleteBranch,
  GetCompany,
  GetBookingCode,
  GetPolicyFindbyId,
  FilterPolicyList,
  GetUserpayablePercentage,
  GetPolicyFileById,
  ReframeEndDateTimeFormat,
} from "../../../Service/_index";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CommonPayableDrawer from "../CommonPayableDrawer/CommonPayableDrawer";
import Loader from "../../../UiComponents/Loader/Loader";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";

import { DatePicker, Radio } from "antd";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Divider, Stack, Badge } from "@mui/material";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import HistoryIcon from "@mui/icons-material/History";
import BulkUploadPayableDialog from "../BulkUpload/BulkUploadPayableDialog";
import BulkUploadHistoryDialog from "../BulkUpload/BulkUploadHistoryDialog";
import {
  VerifyUserPayableBulkUpload,
  BulkUploadUserPayable,
} from "../../../Service/BulkUploadService";

const USER_PAYABLE_TEMPLATE_HEADERS = [
  "Policy Number",
  "User OD %",
  "User OD Amt",
  "User TP %",
  "User TP Amt",
  "User Net %",
  "User Net Amt",
  "User Total",
];

const { RangePicker } = DatePicker;
function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const getClassName = (data) => {
  // return data.policyNumber ? "file_link" : data.CLEAR ? "button-clear" : data.bounce ? "button-bounce": "button-bounce";
  return data.policyNumber ? "file_link" : "";
};

// Format a date for display, guarding missing/unparseable values so the table
// shows "--" instead of "Invalid Date".
const formatPolicyDate = (value) =>
  value && moment(value).isValid()
    ? moment(value).format("DD/MM/YYYY hh:mm A")
    : "--";

const headCells = [
  {
    id: "issueData",
    placeMent: true,
    disablePadding: false,
    label: "Policy Date",
    // The value placed in this column (formateDate) is already a formatted
    // "DD/MM/YYYY hh:mm A" string, so it must NOT be marked type:"date" - the
    // table would try to re-parse that string as a date and render "Invalid
    // Date". Render it as plain text instead.
  },
  {
    id: "companyName",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
    onClick: true,
    class: getClassName,
  },
  {
    id: "customerName",
    placeMent: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "registerationNumber",
    placeMent: true,
    disablePadding: false,
    label: "Reg Number",
  },
  {
    id: "paymentMode",
    placeMent: true,
    disablePadding: false,
    label: "Payment Type",
  },
  {
    id: "payableAmount",
    placeMent: true,
    disablePadding: false,
    label: "Payable Amount",
  },
  {
    id: "email",
    placeMent: true,
    disablePadding: false,
    label: "User Email",
  },
  {
    id: "dynamicAction",
    placeMent: true,
    disablePadding: false,
    label: "Action",
    type: "dynamicAction",
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const BranchPayable = () => {
  const todayDate = new Date();
  const LastWeekDate = new Date();
  LastWeekDate.setDate(LastWeekDate.getDate() - 7);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [policyList, setPolicyList] = React.useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [formType, setFormType] = useState("");
  const [openLoader, setOpenLoader] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedComapny, setSelectedCompany] = useState(null);
  const [selectedBookingCode, setSelectedBookingCode] = useState(null);
  const [filterType, setFilterType] = useState("PENDING");
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [resetValue, setResetValue] = useState(1);
  const [payableType, setPayableType] = useState("");
  const [payablePercentage, setPayablePercentage] = useState({});
  const [selectedPolicyNumber, setSelectedPolicyNumber] = useState("");
  const [count, setCount] = useState(0);
  const [dateRange, setDateRange] = useState();
  const [queryParam, setQueryParam] = useState({
    isPaginationEnabled: true,
    page: 0,
    limit: 5,
    skip: 0,
    search: "",
    sort: "",
  });

  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [tableConfig, setTableConfig] = useState({
    isAction: false,
    isView: false,
    isEdit: false,
    isDelete: false,
    isSearch: false,
    isApprove: false,
  });
  const [FilteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);
  const UserType = sessionStorage.getItem("userType");

  const visibleRows = React.useMemo(
    () =>
      stableSort(
        filter.fn(
          policyList.map((e) => ({
            ...e,
            companyName: e.companyId?.shortName,
          })),
        ),
        getComparator(order, orderBy),
      )?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [order, orderBy, page, rowsPerPage, filter, policyList],
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    // console.log("newPage : ", newPage);
    setQueryParam({
      ...queryParam,
      page: newPage,
      skip: newPage * rowsPerPage,
    });
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    // console.log("handleChangeRowsPerPage", event);
    setRowsPerPage(parseInt(event.target.value, 10));
    setQueryParam({ ...queryParam, limit: event.target.value });
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - policyList.length) : 0;

  const ApproveFunction = (row) => {
    setOpenLoader(true);
    GetPolicyFindbyId(row._id)
      .then((res) => {
        setSelectedData(res?.data);
      })
      .then(() => {
        GetUserpayablePercentage(row._id).then((res) => {
          setFormType("edit");
          setPayableType("userPayable");
          setOpenLoader(false);
          setOpenDrawer(true);
          setPayablePercentage(res?.data);
        });
      });
  };

  const GetPolicyFindbyIdFunction = (row) => {
    setOpenLoader(true);
    GetPolicyFindbyId(row._id).then((res) => {
      setOpenLoader(false);
      setSelectedData(res.data);
      setOpenDrawer(true);
      setFormType("view");
    });
  };

  const onSearch = (e) => {
    let target = e.target;
    // console.log("target ", target.value);
    // setFilter({
    //   fn: (items) => {
    //     if (target.value == "") return items;
    //     else
    //       return items.filter((el) =>
    //         `${el?.policyNumber},${el?.companyId?.companyName},${el.customerName},${el?.registrationNumber},${el?.paymentMode},${el?.email}`
    //           .toLowerCase()
    //           .includes(target.value.toLowerCase())
    //       );
    //   },
    // });
    setQueryParam((queryParams) => ({
      ...queryParams,
      page: 0,
      limit: 5,
      skip: 0,
      search: target.value,
    }));
    setCount(0);
    setPage(0);
  };

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const modifiedCompanyDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails(modifiedCompanyDetails);
    });
  };
  const GetBookingCodeDetails = () => {
    GetBookingCode({ isAscending: true }).then((res) => {
      const modifiedBookingCode = res.data.map((e) => {
        return {
          ...e,
          label: e.bookingCode,
          value: e._id,
        };
      });
      setBookingCodeDetails(modifiedBookingCode);
    });
  };
  React.useEffect(() => {
    GetCompanyDetails();
    GetBookingCodeDetails();
  }, []);

  const PendingData = async () => {
    setTableLoading(true);

    // Changes by Arun
    let endDate = null;
    if (selectedEndDate) {
      endDate = await ReframeEndDateTimeFormat(selectedEndDate);
    }

    queryParam.page = 0;
    queryParam.skip = 0;

    FilterPolicyList({
      companyId: selectedComapny,
      bookingCodeId: selectedBookingCode,
      startDate: selectedStartDate,
      policyNumber: selectedPolicyNumber,
      endDate: endDate,
      type: filterType,
      FilterType: "UTILITES_SCREEN",
      screen: "USER_PAYABLE",
      ...queryParam,
    })
      .then((res) => {
        setTableLoading(false);
        const data = res.data.map((e) => ({
          ...e,
          formateDate: formatPolicyDate(e.issueDate),
        }));
        // .sort((a, b) => new Date(b.approvePendingAt) - new Date(a.approvePendingAt));
        setPolicyList(data);
        // console.log("data[0].totalRecord ", data[0].totalRecord);
        setCount(data[0].totalRecord || count);
      })
      .catch((err) => {
        console.log("err");
      });
  };
  const GetData = async (isPaginationAction) => {
    // Changes by Arun
    if (!selectedPolicyNumber) {
      if (!filterType) {
        ToastError("Please select Filter Type");
        return true;
      }

      if (
        filterType != FilterOptions[0].type &&
        (!selectedStartDate || !selectedEndDate)
      ) {
        ToastError("Please select date range");
        return true;
      }
    }

    setTableLoading(true);
    // Changes by Arun
    let endDate = null;
    if (selectedEndDate) {
      endDate = await ReframeEndDateTimeFormat(selectedEndDate);
    }

    if (!isPaginationAction) {
      queryParam.page = 0;
      queryParam.skip = 0;
    }
    FilterPolicyList({
      companyId: selectedComapny,
      bookingCodeId: selectedBookingCode,
      startDate: selectedStartDate,
      policyNumber: selectedPolicyNumber,
      endDate: endDate,
      type: filterType,
      FilterType: "UTILITES_SCREEN",
      screen: "USER_PAYABLE",
      ...queryParam,
    })
      .then((res) => {
        setTableLoading(false);
        const data = res.data.map((e) => ({
          ...e,
          formateDate:
            filterType === "APPROVE_DATE"
              ? formatPolicyDate(e.userPayable?.updatedAt)
              : formatPolicyDate(e.issueDate),
        }));
        // .sort(
        //   (a, b) =>
        //     new Date(b.approvePendingAt) - new Date(a.approvePendingAt),
        // );
        setPolicyList(data);
        if (data.length > 0) {
          setCount(data[0].totalRecord || count);
        } else {
          setCount(0);
        }
        // Added by Arun
        if (!isPaginationAction) {
          setPage(0);
        }
      })
      .catch((err) => {
        console.log("err");
      });
  };

  useEffect(() => {
    GetData(true);
  }, [queryParam]);
  const ResetFilter = () => {
    setSelectedCompany(null);
    setSelectedBookingCode(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setResetValue(resetValue + 1);
    PendingData();
  };
  const OpenPolicyFile = (row) => {
    setOpenLoader(true);
    GetPolicyFileById(row?._id)
      .then((res) => {
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        setOpenLoader(false);
        // Changes by Arun
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        setOpenLoader(false);
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          // `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
          `<embed src="${blobUrl}" width="100%" height="100%" />`,
        );
        // const pdfWindow = window.open("", "_blank");
        // pdfWindow?.document?.write(`<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`);
      });
  };

  // Changes by Arun
  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };
  const header = [
    { label: "Policy Date", key: "formateDate" },
    { label: "Company Name", key: "companyId.shortName" },
    { label: "Policy Number", key: "policyNumber" },
    { label: "Customer Name", key: "customerName" },
    { label: "Mobile", key: "userId.mobileNumber" }, // Changes by Arun
    { label: "Payment Mode", key: "paymentMode" },
    { label: "Reg Number", key: "registrationNumber" },
    { label: "User Email", key: "userId.email" }, // Changes by Arun
  ];
  // Export fetches every record for the current filters, not just the page
  const csvLinkRef = useRef();
  const [exportData, setExportData] = useState([]);
  const csvFile = {
    filename: "User Payable Data",
    headers: header,
    data: exportData,
  };

  const exportAllRecords = async () => {
    if (!selectedPolicyNumber) {
      if (!filterType) {
        ToastError("Please select Filter Type");
        return;
      }
      if (
        filterType != FilterOptions[0].type &&
        (!selectedStartDate || !selectedEndDate)
      ) {
        ToastError("Please select date range");
        return;
      }
    }
    setOpenLoader(true);
    try {
      let endDate = null;
      if (selectedEndDate) {
        endDate = await ReframeEndDateTimeFormat(selectedEndDate);
      }
      const res = await FilterPolicyList({
        companyId: selectedComapny,
        bookingCodeId: selectedBookingCode,
        startDate: selectedStartDate,
        policyNumber: selectedPolicyNumber,
        endDate: endDate,
        type: filterType,
        FilterType: "UTILITES_SCREEN",
        screen: "USER_PAYABLE",
        ...queryParam,
        isPaginationEnabled: false,
        page: 0,
        skip: 0,
      });
      setExportData(
        res.data.map((e) => ({
          ...e,
          formateDate:
            filterType === "APPROVE_DATE"
              ? formatPolicyDate(e.userPayable?.updatedAt)
              : formatPolicyDate(e.issueDate),
        })),
      );
      // Let the CSV link pick up the new data before it is clicked
      setTimeout(() => csvLinkRef.current?.link?.click(), 0);
    } catch (err) {
      console.log(err);
    } finally {
      setOpenLoader(false);
    }
  };

  const FilterOptions = [
    {
      label: "Pending",
      FilterType: "UTILITES_SCREEN",
      screen: "USER_PAYABLE",
      type: "PENDING",
      _id: "PENDING",
    },
    {
      label: "Issue Date",
      FilterType: "UTILITES_SCREEN",
      screen: "USER_PAYABLE",
      type: "ISSUE_DATE",
      _id: "ISSUE_DATE",
    },
    {
      label: "Approve Date",
      FilterType: "UTILITES_SCREEN",
      screen: "USER_PAYABLE",
      type: "APPROVE_DATE",
      _id: "APPROVE_DATE",
    },
    {
      label: "Cancel Date",
      FilterType: "UTILITES_SCREEN",
      screen: "USER_PAYABLE",
      type: "CANCEL_DATE",
      _id: "CANCEL_DATE",
    },
  ];

  const FilterFunction = (e) => {
    setFilterType(e?.type);
  };

  const originalData = React.useMemo(() => {
    return policyList.map((data) => ({
      _id: data._id,
      issueData: data?.formateDate,
      issueDateFormate: "DD/MM/YYYY hh:mm A",
      companyName: data?.companyId?.shortName,
      policyNumber: data?.policyNumber,
      customerName: data?.customerName,
      registerationNumber: data?.registrationNumber,
      paymentMode: data?.paymentMode,
      payableAmount: data.userPayable?.Total,
      email: data.userId?.email,
      isEdit: data?.status == "cancelled" ? false : data?.isUserPayable,
      isApprove: data?.status == "cancelled" ? false : !data?.isUserPayable,
      isView: true,
      dynamicAction: true,
    }));
  }, [policyList]);

  // Update FilteredData when policyList changes
  useEffect(() => {
    setFilteredData(originalData);
  }, [originalData]);

  // Handle search filtering
  useEffect(() => {
    // Determine if we should trigger a search
    // We want to trigger when searchText changes (handled by input onChange setting page to 0)
    // or when it's cleared
    const delayDebounceFn = setTimeout(() => {
      setQueryParam((prev) => ({
        ...prev,
        search: searchText,
        page: 0,
        skip: 0,
      }));
      setPage(0);
      setSearchTrigger((prev) => prev + 1);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  const handleClearAllState = () => {
    setSelectedCompany(null);
    setSelectedBookingCode(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setFilterType("PENDING");
    setSelectedPolicyNumber("");
    setSearchText("");
    setQueryParam({
      isPaginationEnabled: true,
      page: 0,
      limit: 5,
      skip: 0,
      search: "",
      sort: "",
    });
    setPage(0);
    setSearchTrigger((prev) => prev + 1);
  };

  const handleClearSingleFilter = (filterId) => {
    if (filterId === 1) {
      setSelectedCompany(null);
    } else if (filterId === 2) {
      setSelectedBookingCode(null);
    } else if (filterId === 3) {
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    } else if (filterId === 4) {
      setFilterType("PENDING");
    } else if (filterId === 5) {
      setSelectedPolicyNumber("");
    }
    // Reset pagination when clearing filter
    setQueryParam({
      isPaginationEnabled: true,
      page: 0,
      limit: 5,
      skip: 0,
      search: "",
      sort: "",
    });
    setPage(0);
    setSearchTrigger((prev) => prev + 1);
  };

  const [searchTrigger, setSearchTrigger] = useState(0);

  const handleSaveAllFilter = () => {
    setPage(0);
    setSearchTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    if (searchTrigger > 0) {
      GetData(false);
    }
  }, [searchTrigger]);

  useEffect(() => {
    if (dateRange && Array.isArray(dateRange)) {
      setSelectedStartDate(dateRange[0] || null);
      setSelectedEndDate(dateRange[1] || null);
      // Trigger search after dates are set
      setSearchTrigger((prev) => prev + 1);
    } else {
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    }
  }, [dateRange]);
  const filterBoxData = [
    {
      id: 1,
      label: "Select Company",
      data: companyDetails,
      setState: setSelectedCompany,
      value: selectedComapny,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: "Company code",
      data: bookingCodeDetails,
      setState: setSelectedBookingCode,
      value: selectedBookingCode,
      type: "input",
      variation: "single",
    },
    {
      id: 3,
      setDate: (range) => {
        setDateRange(range);
      },
      value: dateRange,
      type: "noDefaultDate",
    },
    {
      id: 4,
      label: "Filter Type",
      data: FilterOptions,
      setState: setFilterType,
      value: filterType,
      type: "input",
      variation: "single",
      // value: FilterOptions.find(opt => opt.type === filterType)?._id,
      // defaultValue: FilterOptions.find(option => option.type === "PENDING")?._id
    },
    {
      id: 5,
      label: "Policy Number",
      setState: setSelectedPolicyNumber,
      value: selectedPolicyNumber,
      type: "normalInput",
    },
  ];
  // console.log("policy List: ", policyList);
  // console.log("searchFiltered data: ", SearchFilteredData);

  const activeFiltersCount =
    [
      selectedComapny,
      selectedBookingCode,
      filterType,
      selectedPolicyNumber,
    ].filter(Boolean).length + (dateRange?.[0] ? 1 : 0);

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    User Payable
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap" sx={{ width: "100%" }}>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <Badge
                            badgeContent={activeFiltersCount}
                            color="error"
                            sx={{
                              "& .MuiBadge-badge": {
                                right: 5,
                                top: 3,
                                width: "14px",
                                height: "14px",
                                minWidth: "14px",
                                borderRadius: "50%",
                                fontSize: "8.91px",
                                fontWeight: "600",
                                backgroundColor: "#E50000",
                                color: "#fff",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <FilterListIcon sx={{ marginRight: "1.5px" }} />
                          </Badge>
                        }
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        Filters
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <CloudDownloadOutlinedIcon
                            sx={{
                              color: "#344054",
                            }}
                          />
                        }
                        onClick={exportAllRecords}
                      >
                        Export
                      </Button>
                      <CSVLink
                        ref={csvLinkRef}
                        style={{ display: "none" }}
                        {...csvFile}
                      />
                      {UserType === "CLIENT" && (
                        <Button
                          className="Master_Card_Filter_Button w-100"
                          sx={{ width: "130px", height: "40px", gap: "8px" }}
                          startIcon={
                            <CloudUploadOutlinedIcon
                              sx={{ color: "#344054" }}
                            />
                          }
                          onClick={() => setBulkUploadOpen(true)}
                        >
                          Bulk Upload
                        </Button>
                      )}
                      {UserType === "CLIENT" && (
                        <Button
                          className="Master_Card_Filter_Button w-100"
                          sx={{ width: "150px", height: "40px", gap: "8px" }}
                          startIcon={<HistoryIcon sx={{ color: "#344054" }} />}
                          onClick={() => setHistoryOpen(true)}
                        >
                          Uploaded Files
                        </Button>
                      )}
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                    sx={{
                      "& .filter-box-container": {
                        boxShadow: "none",
                        border: "none",
                        p: 0,
                      },
                      "& .MuiPaper-root": {
                        boxShadow: "none",
                        border: "none",
                        p: 0,
                      },
                    }}
                  />
                </Box>
              )}

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>

              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
                className="Master_Card_Sub_Container"
              >
                <Grid item xs={12} sm={6} />
                <Grid item xs={12} sm={4} md={3.1}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search "
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>

              <MasterCommonTable
                tableConfig={tableConfig}
                loading={tableLoading}
                data={FilteredData}
                columns={headCells}
                handleOnClickBehaviour={OpenPolicyFile}
                handleApprove={ApproveFunction}
                handleView={GetPolicyFindbyIdFunction}
                handleEdit={ApproveFunction}
                isServerSide={true}
                tableTotalCount={count}
                tableOutputEvent={(params) => {
                  setQueryParam((prev) => ({
                    ...prev,
                    page: params.page - 1,
                    limit: params.limit,
                    sort: params.sort,
                    sortType: params.sortType,
                    skip: (params.page - 1) * params.limit,
                  }));
                }}
                paginationReset={
                  selectedComapny +
                  selectedBookingCode +
                  filterType +
                  selectedPolicyNumber +
                  searchText +
                  searchTrigger
                }
              />
            </Grid>
          </Box>
        </Box>
      </div>
      <Loader open={openLoader} />

      <Drawer
        open={openDrawer}
        anchor="right"
        onClose={() => setOpenDrawer(false)}
        sx={{
          zIndex: 1300,
          "& .MuiDrawer-paper": {
            width: { xs: "100%", sm: "650px", md: "650px" },
            boxSizing: "border-box",
          },
        }}
      >
        {openDrawer ? (
          <CommonPayableDrawer
            UserPayablePercentage={payablePercentage}
            setOpenDrawer={setOpenDrawer}
            formType={formType}
            selectedData={selectedData}
            path={"userPayable"}
            GetData={GetData}
            payableType={payableType}
          />
        ) : null}
      </Drawer>

      <BulkUploadPayableDialog
        open={bulkUploadOpen}
        setOpen={setBulkUploadOpen}
        onSuccess={() => GetData(false)}
        title="Bulk Upload User Payable"
        templateHeaders={USER_PAYABLE_TEMPLATE_HEADERS}
        templateFileName="User_Payable_Bulk_Upload_Template.xlsx"
        verifyService={VerifyUserPayableBulkUpload}
        commitService={BulkUploadUserPayable}
      />

      <BulkUploadHistoryDialog
        open={historyOpen}
        setOpen={setHistoryOpen}
        defaultType="Userpayable"
        title="User Payable — Bulk Upload History"
      />
    </>
  );
};
export default BranchPayable;
